import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  ClipboardList, 
  Users, 
  HeartHandshake, 
  FileText, 
  MessageSquareWarning, 
  Newspaper, 
  Video, 
  ArrowRight, 
  Link as LinkIcon, 
  Phone, 
  FileSearch 
} from 'lucide-react';

const quickLinksList = [
  { icon: FileText, label: 'Certificate Application', path: '/form-filling' },
  { icon: FileSearch, label: 'Check Application Status', path: '/status-check' },
  { icon: ClipboardList, label: 'Govt. Schemes', path: '/yojna' },
  { icon: HeartHandshake, label: 'Pension Services', path: '/pension' },
  { icon: MessageSquareWarning, label: 'Register Complaint', path: '/complaints' },
  { icon: Phone, label: 'Contact Us', path: '/contact' },
  { icon: Newspaper, label: 'Village Blog', path: '/blogs' },
  { icon: Video, label: 'Video Gallery', path: '/videos' },
  { icon: Users, label: 'Join WhatsApp Group', path: 'https://chat.whatsapp.com/CoX5dmQ4r9W4Di3DkzNcQx', external: true },
  { icon: FileText, label: 'Birth/Death Certificate', path: 'https://edistrict.up.gov.in', external: true },
];

const QuickLinks = () => {
  return (
    <div className="bg-white p-4 sm:p-6 rounded-xl shadow-md border border-slate-200/80">
      <div className="flex items-center mb-5">
        <LinkIcon className="text-blue-500" size={22}/>
        <h2 className="text-xl font-bold text-slate-800 ml-2">Quick Links</h2>
      </div>
      
      <div className="space-y-2">
        {quickLinksList.map((link, index) => {
          const LinkContent = () => (
            <div className="flex items-center p-3 bg-slate-50/80 rounded-lg hover:bg-blue-50 transition-colors duration-200 group">
                <link.icon size={20} className="text-blue-600 mr-4 flex-shrink-0" />
                <span className="font-semibold text-slate-700 group-hover:text-blue-800 flex-grow">{link.label}</span>
                <ArrowRight size={16} className="text-slate-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-transform"/>
            </div>
          );

          if (link.external) {
            return (
              <a key={index} href={link.path} target="_blank" rel="noopener noreferrer">
                <LinkContent />
              </a>
            );
          } else {
            return (
              <RouterLink key={index} to={link.path}>
                <LinkContent />
              </RouterLink>
            );
          }
        })}
      </div>
    </div>
  );
}

export default QuickLinks;
